import React from 'react';

const YellowDashCentered = () => <div style={{ height: '5px', width: '35px', margin: '20px auto 0 auto' }} className="bg-warning" />;

export default YellowDashCentered;
